import { handleAction } from 'redux-actions';
import { combineReducers } from 'redux';
import { converge, mergeRight } from 'ramda';

import { defaultTheme } from 'app/styles/constants/theme';
import { UPDATE_THEME_MARKUP } from 'app/styles/constants/actionTypes';
import { pickState, pickPayload } from 'app/reducers/helpers';

const markup = handleAction(
  UPDATE_THEME_MARKUP,
  converge(mergeRight, [pickState, pickPayload]),
  defaultTheme.markup,
);

const theme = combineReducers({ markup, global: () => defaultTheme.global });

export { markup };

export default theme;
